"use strict";

var _objectSpread = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/helpers/objectSpread");

var _regeneratorRuntime = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/helpers/asyncToGenerator");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var app_1 = __importDefault(require("firebase/app"));

var Auth = __importStar(require("./auth"));

var Groups = __importStar(require("./groups"));

var firebase_1 = require("../../configs/firebase");

var UtilsArray = __importStar(require("../../utils/array"));

var my_error_1 = __importDefault(require("../../models/my-error"));

var _cacheLastItemForList = null;

function _build(snapshot) {
  return Object.assign({}, snapshot.data(), {
    id: snapshot.id
  });
}

function checkIfFollowed(_x) {
  return _checkIfFollowed.apply(this, arguments);
}

function _checkIfFollowed() {
  _checkIfFollowed = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(groupId) {
    var docSnapshot;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getByGroupId(groupId);

          case 2:
            docSnapshot = _context.sent;
            return _context.abrupt("return", !!docSnapshot);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _checkIfFollowed.apply(this, arguments);
}

exports.checkIfFollowed = checkIfFollowed;

function follow(_x2) {
  return _follow.apply(this, arguments);
}

function _follow() {
  _follow = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(groupId) {
    var userId, docRef, docSnapshot, followedGroup, group;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return checkIfFollowed(groupId);

          case 2:
            if (!_context2.sent) {
              _context2.next = 6;
              break;
            }

            throw new my_error_1.default("You had followed this database before");

          case 6:
            _context2.next = 8;
            return Auth.getUserId();

          case 8:
            userId = _context2.sent;
            _context2.next = 11;
            return app_1.default.firestore().collection(firebase_1.CN_FOLLOWED_GROUPS).add({
              create_at: app_1.default.firestore.FieldValue.serverTimestamp(),
              user_id: userId,
              group_id: groupId
            });

          case 11:
            docRef = _context2.sent;
            _context2.next = 14;
            return docRef.get();

          case 14:
            docSnapshot = _context2.sent;

            if (!docSnapshot.exists) {
              _context2.next = 27;
              break;
            }

            followedGroup = _build(docSnapshot);
            _context2.next = 19;
            return Groups.getById(groupId);

          case 19:
            group = _context2.sent;

            if (!group) {
              _context2.next = 24;
              break;
            }

            return _context2.abrupt("return", _objectSpread({}, followedGroup, {
              _group: group
            }));

          case 24:
            throw new Error("Can not find group object from server");

          case 25:
            _context2.next = 28;
            break;

          case 27:
            throw new Error("Can not get the followed group which is just added");

          case 28:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _follow.apply(this, arguments);
}

exports.follow = follow;

function unfollow(_x3) {
  return _unfollow.apply(this, arguments);
}

function _unfollow() {
  _unfollow = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(groupId) {
    var followDocSnapshot;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getByGroupId(groupId);

          case 2:
            followDocSnapshot = _context3.sent;

            if (!followDocSnapshot) {
              _context3.next = 8;
              break;
            }

            _context3.next = 6;
            return app_1.default.firestore().collection(firebase_1.CN_FOLLOWED_GROUPS).doc(followDocSnapshot.id).delete();

          case 6:
            _context3.next = 9;
            break;

          case 8:
            throw new my_error_1.default("You are not following this database");

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _unfollow.apply(this, arguments);
}

exports.unfollow = unfollow;

function unfollowById(_x4) {
  return _unfollowById.apply(this, arguments);
}

function _unfollowById() {
  _unfollowById = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(id) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return app_1.default.firestore().collection(firebase_1.CN_FOLLOWED_GROUPS).doc(id).delete();

          case 2:
            return _context4.abrupt("return", id);

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _unfollowById.apply(this, arguments);
}

exports.unfollowById = unfollowById;

function getList() {
  return _getList.apply(this, arguments);
}

function _getList() {
  _getList = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5() {
    var userId, query, querySnapshot, followedGroups, ids, groups, result;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return Auth.getUserId();

          case 2:
            userId = _context5.sent;
            query = app_1.default.firestore().collection(firebase_1.CN_FOLLOWED_GROUPS).where('user_id', '==', userId).orderBy('create_at', 'desc').limit(firebase_1.FOLLOWED_GROUPS_FETCH_LIMIT);

            if (_cacheLastItemForList) {
              query = query.startAfter(_cacheLastItemForList);
            }

            _context5.next = 7;
            return query.get();

          case 7:
            querySnapshot = _context5.sent;
            followedGroups = [];

            if (querySnapshot.size > 0) {
              querySnapshot.forEach(function (docSnapshot) {
                followedGroups.push(_build(docSnapshot));
              });
              _cacheLastItemForList = followedGroups[followedGroups.length - 1].create_at;
            }

            ids = followedGroups.map(function (followedGroup) {
              return followedGroup.group_id;
            });
            _context5.next = 13;
            return Groups.getListByIds(ids);

          case 13:
            groups = _context5.sent;
            result = UtilsArray.lookup(followedGroups, groups, 'group_id', 'id', '_group');
            return _context5.abrupt("return", result);

          case 16:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getList.apply(this, arguments);
}

exports.getList = getList;

function reload() {
  return _reload.apply(this, arguments);
}

function _reload() {
  _reload = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6() {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _cacheLastItemForList = null;
            return _context6.abrupt("return", getList());

          case 2:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _reload.apply(this, arguments);
}

exports.reload = reload;

function getByGroupId(_x5) {
  return _getByGroupId.apply(this, arguments);
}

function _getByGroupId() {
  _getByGroupId = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee7(groupId) {
    var userId, querySnapshot;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return Auth.getUserId();

          case 2:
            userId = _context7.sent;
            _context7.next = 5;
            return app_1.default.firestore().collection(firebase_1.CN_FOLLOWED_GROUPS).where('group_id', '==', groupId).where('user_id', '==', userId).orderBy('create_at', 'desc').limit(1).get();

          case 5:
            querySnapshot = _context7.sent;

            if (!querySnapshot.empty) {
              _context7.next = 10;
              break;
            }

            return _context7.abrupt("return", null);

          case 10:
            return _context7.abrupt("return", querySnapshot.docs[0]);

          case 11:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _getByGroupId.apply(this, arguments);
}

exports.getByGroupId = getByGroupId;